import {Component, h} from 'preact';
import Modal from '@components/common/Modal';
import Button from '../common/Button';
import Cookie from 'js-cookie';
import {SITE_URL} from '@util/URLUtils'

const DIALOG_TITLE = upi.i18n.getTextFromKey( 'lbl-dentalProfessional', 'Are you a dental professional?');
const DIALOG_PHRASE = upi.i18n.getTextFromKey( 'lbl-dentalProfessionalPhrase');
const LBL_YES = upi.i18n.getTextFromKey( 'wrd-Yes', 'Yes');
const LBL_NO = upi.i18n.getTextFromKey( 'wrd-No', 'No');

class DentalProDialog extends Component {
    state = {
        isOpen: true
    };

    handleAction = actionType => e => {
        switch(actionType) {
            case 'yes':
                Cookie.set('UpiDentalProfessional', true);
                this.setState({ isOpen: false });
                break;

            case 'no':
            default:
                window.location = SITE_URL;

        }
    };

    render() {
        return (
            <Modal id="isDentalProDialog"
                   title="Ultradent.com"
                   shouldCloseOnOverlayClick={false}
                   isOpen={this.state.isOpen}>
                <div className="max-w-sm">
                    <section>
                        <h1 className="font-normal mb-2">{DIALOG_TITLE}</h1>
                        <p>{DIALOG_PHRASE}</p>
                        <div className="flex justify-between mt-8 button-bar">
                            <Button secondary onClick={this.handleAction('no')}>{LBL_NO}</Button>
                            <Button onClick={this.handleAction('yes')}>{LBL_YES}</Button>
                        </div>
                    </section>
                </div>
            </Modal>
        );
    }
}

export default DentalProDialog;